import actionTypes from "../actionTypes";

export const FETCH_WEB_HOOKS = actionTypes("FETCH_WEB_HOOKS");
export const CREATE_WEB_HOOK = actionTypes("CREATE_WEB_HOOK");
export const DELETE_WEB_HOOK = actionTypes("DELETE_WEB_HOOK");
